import React from "react";
import Cx from "classnames";

import Modal from "../Modal";
import * as styles from "./ExportSpreadsheet.module.scss";
import FieldList from "./FieldList";

// TODO -- maybe define this in the Rails database or codebase
const fieldSchema = [
  {
    name: "title",
    label: "Name",
  },
  {
    name: "company",
    label: "Company",
  },
  {
    name: "email",
    label: "Email",
  },
  {
    name: "role",
    label: "Type",
  },
  {
    name: "parsed_address",
    label: "Address",
  },
  {
    name: "phone",
    label: "Phone",
  },
  {
    name: "notes",
    label: "Notes",
  },
  {
    name: "links",
    label: "Links",
  },
  {
    name: "docs_url_list",
    label: "Documents",
  },
];

const defaultState = {
  open: false,
  items: [],
  // select all by default
  selectedFields: fieldSchema.map((x) => Object.values(x)[0]),
  selectAllStarred: false,
  status: "",
  error: "",
};

export default class ExportContacts extends React.Component {
  state = defaultState;

  componentDidMount() {
    window.addEventListener(
      "openExportContactsReactComponent",
      this.handleOpen
    );
  }

  componentDidUpdate() {
    // get information about the selected items
    const { items } = this.state;
    const newItems = [];

    document
      .querySelectorAll(".bulk-actions-checkbox:checked")
      .forEach((element) => {
        const { id, classname } = element.dataset;
        if (classname === "Contact") newItems.push({ id, classname });
      });

    if (JSON.stringify(items) !== JSON.stringify(newItems)) {
      this.setState({ items: newItems });
    }
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = (e) => {
    e.stopPropagation();
    this.setState(defaultState);
  };

  handleSelectAllStarred = () => {
    this.setState({ selectAllStarred: true });
  };

  handleSelectField = (e) => {
    const { selectedFields } = this.state;
    const { fieldName } = e.target.dataset;
    const newSelectedFields = selectedFields.includes(fieldName)
      ? selectedFields.filter((field) => field !== fieldName)
      : selectedFields.concat([fieldName]);

    this.setState({ selectedFields: newSelectedFields });
  };

  handleSelectAll = () => {
    this.setState({
      selectedFields: fieldSchema.map((field) => field.name),
    });
  };

  handleSelectNone = () => {
    this.setState({ selectedFields: [] });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { selectedFields, selectAllStarred, error } = this.state;
    const { allIds } = this.props;
    const checkedIds = [];

    if (error) this.setState({ error: "" });
    this.setState({ status: "loading" });

    $("tr.row-contact .bulk-actions-checkbox:checked").each(function (
      index,
      el
    ) {
      checkedIds.push($(el).attr("data-id"));
    });
    const allStarredContactIds = allIds
      .filter((record) => record.type === "Contact")
      .map((record) => record.id);

    const allContacts = selectAllStarred ? allStarredContactIds : checkedIds;

    if (!selectedFields.length || !checkedIds.length) {
      this.setState({
        error:
          "Please ensure that you have selected at least one contact record and one field.",
      });
      return;
    }

    const data = {
      all_contacts: allContacts.join(","),
      all_attributes: selectedFields.join(","),
    };

    const that = this;

    $.ajax({
      method: "POST",
      url: "/export_contacts",
      data,
    })
      .done((data) => {
        that.setState({ status: "success", error: "" });
      })
      .fail(function () {
        that.setState({ status: "", error: "Your request failed." });
      });
  };

  render() {
    const { open, items, selectedFields, selectAllStarred, status, error } =
      this.state;
    const { email, allIds } = this.props;
    const selectedItems = selectAllStarred ? allIds : items;

    const Layout = ({ children }) => (
      <Modal isOpen={open} onClose={this.handleClose}>
        {children}
      </Modal>
    );

    if (!selectedItems.length) {
      return (
        <Layout>
          <h1 className={styles.h1}>Export to spreadsheet</h1>
          <p>
            You haven't selected any contact records. Please click the
            checkboxes next to the contact records that you would like to
            export.
          </p>
        </Layout>
      );
    }

    if (status === "success") {
      return (
        <Layout>
          <p>
            Your spreadsheet is being generated. We will email you at {email}{" "}
            when the spreadsheet is complete.
          </p>
        </Layout>
      );
    }

    let message = (
      <p>
        You have selected {selectedItems.length} contact record
        {selectedItems.length === 1 ? "" : "s"}. Select the fields that you
        would like to export to a spreadsheet.
      </p>
    );

    if (allIds.length > selectedItems.length && !selectAllStarred) {
      message = (
        <>
          <p>
            You have selected {selectedItems.length} contact record
            {selectedItems.length === 1 ? "" : "s"}. Select the fields that you
            would like to export to a spreadsheet.
          </p>
          <p style={{ marginTop: "16px" }}>
            <a
              role="button"
              onClick={this.handleSelectAllStarred}
              className={styles.selectAllButton}
            >
              Click here to select all {allIds.length} contact records in this
              search result.
            </a>
          </p>
        </>
      );
    }

    return (
      <Layout>
        <h1 className={styles.h1}>Export contact records to spreadsheet</h1>
        {message}
        <FieldList
          fieldSchema={fieldSchema}
          selectedFields={selectedFields}
          onSelectField={this.handleSelectField}
          onSelectAll={this.handleSelectAll}
          onSelectNone={this.handleSelectNone}
        />
        <p>
          <em>
            Note: after clicking the "request spreadsheet" button you will be
            sent a link to the spreadsheet via email.
          </em>
        </p>
        <div className={styles.submitArea}>
          {!!error && <p>{error}</p>}
          <button
            onClick={this.handleSubmit}
            className={Cx(
              { [styles.buttonLoading]: status === "loading" },
              styles.submit
            )}
          >
            Request spreadsheet
          </button>
        </div>
      </Layout>
    );
  }
}
